// Test mode
export const PUBLISHABLE_KEY =
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY ||
  "pk_test_51JIwkiIw32j2vNMficwM2Yq0aFRI2SYjAQLmeU5mGhgOXCOooDlkLRoErncTg2HX1HHyRZzD2xlskoinaocGvSpL00WrRbsXKI";
